import React from "react";
// import { LineChart } from "@mui/x-charts/LineChart";
import { IconButton, Tooltip } from "@mui/material";
import { t } from "i18next";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { ResponsiveChartContainer } from "@mui/x-charts/ResponsiveChartContainer";
import { LinePlot, MarkPlot } from "@mui/x-charts/LineChart";
import { BarPlot } from "@mui/x-charts/BarChart";
import { ChartsXAxis } from "@mui/x-charts/ChartsXAxis";
import { ChartsYAxis } from "@mui/x-charts/ChartsYAxis";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { ChartsGrid } from "@mui/x-charts/ChartsGrid";
import { ChartsTooltip } from "@mui/x-charts/ChartsTooltip";
import { ROLE } from "../../../../../utils/constants/profiles";
import { useSelector } from "react-redux";

const CardLineChart = ({ dataMonth, downloadExcel }) => {
  const role = useSelector((state) => state.app.role);
  const mesi = [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre",
  ];

  const ordineMesi =
    dataMonth.length === 12
      ? dataMonth
      : [
          ...Array(12)
            .fill()
            .map((_, index) => ({
              label: mesi[index],
              uploaded: 0,
              validated: 0,
              pending: 0,
              rejected: 0,
              month: index + 1,
              year: new Date().getFullYear(),
            })),
          ...dataMonth,
        ].reduce((acc, curr) => {
          const existingMonth = acc.find((item) => item.month === curr.month);
          if (existingMonth) {
            return acc.map((item) => (item.month === curr.month ? curr : item));
          }
          return [...acc, curr];
        }, []);

  return (
    <div className="flex-col  h-full p-3 shadow-md rounded-lg">
      <div className="flex w-full justify-between p-3">
        <p className="text-2xl font-bold m-0 ">Riepilogo Mensile</p>
        {ROLE.USER !== role && (
          <Tooltip title={t("Download")}>
            <IconButton
              className="hidden" //disabled download
              onClick={() => downloadExcel("monthly")}
            >
              <DownloadRoundedIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className="flex justify-center">
        <ResponsiveChartContainer
          xAxis={[
            {
              scaleType: "band",
              id: "months",
              label: "Mesi",
              data: mesi,
              categoryGapRatio: 0.7,
            },
          ]}
          yAxis={[
            {
              id: "validated",
              label: "Documenti Controllati",
              min: 0,
              max: Math.max(...ordineMesi.map((item) => item.uploaded)),
            },
            {
              id: "pending",
              label: "Da Controllare",
              min: 0,
              max: Math.max(...ordineMesi.map((item) => item.uploaded)),
            },
            {
              id: "rejected",
              label: "Scartati",
              min: 0,
              max: Math.max(...ordineMesi.map((item) => item.uploaded)),
            },
            {
              id: "uploaded",
              label: "Documenti Caricati",
            },
          ]}
          dataset={ordineMesi}
          series={[
            {
              type: "line",
              id: "validated",
              yAxisId: "validated",
              dataKey: "validated",
              label: "Controllati",
              color: "#359F1C",
            },
            {
              type: "line",
              id: "pending",
              yAxisId: "pending",
              dataKey: "pending",
              label: "Da Controllare",
              color: "#d86f07",
            },
            {
              type: "line",
              id: "rejected",
              yAxisId: "rejected",
              dataKey: "rejected",
              label: "Scartati",
              color: "#c1272d",
            },
            {
              type: "bar",
              id: "uploaded",
              yAxisId: "uploaded",
              dataKey: "uploaded",
              label: "Caricati",
              color: "#d2d2d2",
            },
          ]}
          height={500}
          margin={{ left: 70, right: 70 }}
          sx={{
            [`.${axisClasses.left} .${axisClasses.label}`]: {
              transform: "translate(-25px, 0)",
            },
            [`.${axisClasses.right} .${axisClasses.label}`]: {
              transform: "translate(30px, 0)",
            },
          }}
        >
          <ChartsGrid vertical horizontal />
          <BarPlot borderRadius={100} />
          <LinePlot />
          <MarkPlot />
          <ChartsXAxis axisId="months" label="Mesi" />
          <ChartsYAxis axisId="uploaded" label="Documenti Caricati" />
          <ChartsTooltip />
        </ResponsiveChartContainer>
      </div>
    </div>
  );
};

export default CardLineChart;
